import {CoinIcon} from 'components/Sharpenny'

/**
 * The little coin badge shown beside a button whose action currently
 * earns Sharpennies — same coin the invite page hangs after "When your
 * friend signs up, you earn N Sharpennies!". Render it only when the
 * trigger is available to this member (see useRewardAvailability);
 * pass the trigger's entry and it hides itself otherwise.
 */
const RewardCoinHint = ({entry, className = ''}) => {
  if (!entry?.available) return null
  return (
    <CoinIcon
      title={`Earn ${entry.amount} Sharpennies`}
      className={`w-4 h-4 ${className}`}
    />
  )
}

export default RewardCoinHint
